import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const links = [
  { label: '档案首页', to: '/' },
  { label: '实锤证据库', to: '/archive' },
  { label: '辟谣反锤', to: '/archive?view=debunk' },
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const submit = () => {
    navigate(`/archive${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ''}`);
    setOpen(false);
  };

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap px-1 py-2 text-sm transition-colors ${
      isActive ? 'text-primary-600 font-semibold' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/80'
          : 'bg-background-50'
      }`}
    >
      {/* 顶栏细标 */}
      <div className="hidden md:flex items-center justify-between bg-foreground-950 text-background-200 text-xs px-4 md:px-6 lg:px-10 py-1.5">
        <p className="truncate">
          <span className="inline-flex items-center gap-1.5 mr-2 text-background-50">
            <i className="ri-flashlight-line text-secondary-300"></i>最新补档
          </span>
          某旅行团强制购物争议新录音已补档 · 短视频课程投诉新增一期证据
        </p>
        <p className="hidden lg:flex items-center gap-4 whitespace-nowrap">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-time-line text-secondary-300"></i>素材实时归拢中
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-400"></i>逐条标注来源
          </span>
        </p>
      </div>

      <div className="flex items-center gap-4 md:gap-6 px-4 md:px-6 lg:px-10 h-16">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 group" aria-label="69爆料 首页">
          <span className="stamp text-sm font-bold px-2 py-0.5 group-hover:rotate-0 transition-transform">
            69
          </span>
          <span className="leading-none">
            <span className="block font-display font-bold text-foreground-950 text-lg tracking-wide">
              69爆料
            </span>
            <span className="block text-[10px] text-foreground-500 tracking-[0.3em] mt-0.5">
              看证据 · 不站队
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 mx-auto" aria-label="主导航">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === '/'} className={navClass}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2.5 ml-auto">
          <form
            className="hidden xl:flex items-center gap-2 border border-background-300 rounded-full pl-3 pr-1 py-1 focus-within:border-primary-400 bg-background-100/60"
            onSubmit={(e) => {
              e.preventDefault();
              submit();
            }}
          >
            <i className="ri-search-line text-foreground-500 text-sm"></i>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="bg-transparent text-sm w-44 outline-none placeholder:text-foreground-400"
              placeholder="搜事件 / 人物 / 素材"
              aria-label="站内搜索"
            />
            <button
              type="submit"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 text-xs rounded-full px-3 py-1.5 whitespace-nowrap transition-colors"
            >
              检索
            </button>
          </form>
          <Link
            to="/about#contact"
            className="hidden lg:inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap transition-colors"
          >
            <i className="ri-megaphone-line"></i>我要投稿
          </Link>
        </div>

        {/* 移动端汉堡 */}
        <button
          className="lg:hidden ml-auto flex items-center justify-center w-10 h-10 rounded-md text-foreground-800"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
        >
          <i className={`ri-${open ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {/* 移动端下拉 */}
      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4 flex flex-col gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `px-3 py-2.5 rounded-md text-sm ${
                  isActive ? 'bg-primary-100 text-primary-700 font-semibold' : 'text-foreground-800'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <div className="flex gap-2 mt-2 px-1">
            <form
              className="flex flex-1 items-center gap-2 border border-background-300 rounded-full px-3 py-2"
              onSubmit={(e) => {
                e.preventDefault();
                submit();
              }}
            >
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                className="bg-transparent text-sm flex-1 outline-none"
                placeholder="搜事件 / 人物"
                aria-label="站内搜索"
              />
            </form>
            <button
              onClick={() => setOpen(false)}
              className="bg-primary-500 text-background-50 text-sm px-4 rounded-full whitespace-nowrap"
            >
              检索
            </button>
          </div>
        </div>
      )}
    </header>
  );
}